import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSpotsAction } from 'actions/actions';
import { AppState } from 'reducers/reducers';
import { selectedSpotId, selectedSpotInfo } from 'selectors';
import { trackPageViewed } from 'utils/analytics';
import { VisitorKioskProvider } from 'contexts/VisitorKioskContext';
import { useOrganization } from 'contexts/OrganizationsContext';
import ValidationForm from 'components/Dashboard/ValidationForm/ValidationForm';
import VisitorPlates from 'components/Dashboard/VisitorPlates/VisitorPlates';
import Loader from 'components/Loader/Loader';
import styles from './ValidationRequestsModuleContainer.module.css';

type ValidationRequestsModuleContainerProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

function ValidationRequestsModuleContainer({
    router,
    spotId,
    spot,
    orgSpotsLoading,
    profile,
    getSpots,
}: ValidationRequestsModuleContainerProps) {
    const { organization } = useOrganization();

    useEffect(() => {
        if (!spot && !orgSpotsLoading) {
            getSpots();
        }
    }, [spot, orgSpotsLoading, getSpots]);

    useEffect(() => {
        trackPageViewed({
            pageName: 'Kiosk',
            spotId,
            organizationId: organization?.pk,
            affiliationRole: organization?.role,
            superuser: profile.superuser,
        });
    }, [spotId, organization?.pk, organization?.role, profile.superuser]);

    return (
        <VisitorKioskProvider>
            <div>
                <div className={styles.header}>
                    <img
                        src="https://assets.website-files.com/5d55f1425cb6b7a18aa77528/5d55f8a49a649a59aab64b1c_airgarage-logo.png"
                        alt="logo"
                        width="400"
                    />
                    <div>
                        {spot ? <h3>{spot.name}</h3> : <Loader />}
                        <ValidationForm spotId={spotId} />
                    </div>
                </div>
                <VisitorPlates spotId={spotId} router={router} />
            </div>
        </VisitorKioskProvider>
    );
}

function mapStateToProps(state: AppState) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        spotId: selectedSpotId(state)!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profile: state.auth.profile!,
        spot: selectedSpotInfo(state),
        orgSpotsLoading: state.spots.orgSpotsLoading,
        router: state.router,
    };
}
const mapDispatchToProps = {
    getSpots: getSpotsAction,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ValidationRequestsModuleContainer));
